export const NANOCOSMOS_ACCOUNT_ID = 'ezugi';
export const NANOCOSMOS_ACCOUNT_KEY = 'ez1jfdkwzndhjkfze';
export const NANOCOSMOS_LOG_INTERVAL = 10;
export const NANOCOSMOS_EVENT = 'BLACKJACK';
export const NANOCOSMOS_VIDEO_PLAYER_ID = 'video-container';
